export default __webpack_public_path__ + "static/media/Glove5.7c8d5aac.svg";